export interface MediaDto {
  relatedType: string; // Equivalente a related_type en el primer modelo
  relatedId: string; // Equivalente a related_id en el primer modelo
  field: string; // Nombre del campo relacionado en la base de datos
  originalName: string; // Nombre original del archivo
  fileName: string; // Nombre del archivo en el sistema (como identificador único)
  mimeType: string; // Tipo MIME del archivo
  extension: string; // Extensión del archivo, por ejemplo, '.jpg', '.png', etc.
  size: number; // Tamaño del archivo en bytes
  location: string; // Define la ubicación del almacenamiento (Google, AWS, etc.)
  path: string; // Ruta completa al archivo
  key: string; // Clave única para acceder al archivo en almacenamiento externo
}

export interface MediaOutDto {
  field: string; // Nombre del campo relacionado en la base de datos
  originalName: string; // Nombre original del archivo
  fileName: string; // Nombre del archivo en el sistema (como identificador único)
  mimeType: string; // Tipo MIME del archivo
  extension: string; // Extensión del archivo, por ejemplo, '.jpg', '.png', etc.
  size: number; // Tamaño del archivo en bytes
  location: string; // Define la ubicación del almacenamiento (Google, AWS, etc.)
  path: string; // Ruta completa al archivo
  key: string; // Clave única para acceder al archivo en almacenamiento externo
}

export interface MediaInDto extends MediaDto {
  _id: string; // Nombre del campo relacionado en la base de datos
  url: string
}

export enum MediaActions {
  READ = 'getObject',
  WRITE = 'putObject',
  DELETE = 'deleteObject'
}

export enum MediaEntities {
  INSPECTION = 'inspection',
  PERIODIC_CHECK = 'periodic-check',
  USER = "user",
  CUSTOMER = "customer",
  RESPONSIBLE = "responsible",
  COMPANY = "company",
}

export interface GetMediaOutDto {
  key: string,
  mimeType: string,
  action: 'getObject' | 'putObject',
  expiration: number
}


export interface NewFileOutDto {
  file: File,
  fileName: string;
  onUploadProgress: (progress: number) => void
  onAbort?: (xhr: XMLHttpRequest) => void
}
export interface NewFileInDto {

}